export const isAdvancedPhotoGalleryEnabled = (value) => value === true || Number(value) === 1;

export const getCanonicalSystemSettingsLocation = ({search = '', hash = ''} = {}) => ({
	pathname: '/main/systemsettings',
	search,
	hash
});

export const resolvePhotoVersion = (photoGalleryConfigLoaded, defaultPhotoGallery) => {
	if (!photoGalleryConfigLoaded) return null;
	return defaultPhotoGallery ? 2 : 1;
};
